import { colors, Table, TableHeader, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ContentStyled = styled.div`
  padding-bottom: 5rem;
`;

export const TableWrapperStyled = styled.div`
  background-color: ${colors.neutral.white};
  border-radius: 1rem;
  padding-bottom: 1rem;
  overflow: hidden;
  box-shadow: ${boxShadows.dark[4]};
  max-width: 100%;
  margin: 0 auto 5rem;
`;

export const TemplateTableStyled = styled(Table)`
  width: max(100%, 135rem);
`;

export const TableHeaderStyled = styled(TableHeader)`
  box-sizing: border-box;
`;

export const TableHeadingStyled = styled(TableHeading)`
  padding: 1.6rem 1rem;
  background-color: ${TABLE_HEADER_BG_COLOR};
`;

export const HeadingsRowStyled = styled(TableRow)`
  border-top: 0.1rem solid ${colors.neutral[500]};
`;
